export default __webpack_public_path__ + "static/marketplace-submenu-11560ed3cd4031acdd380755082ac3c1.png";